import { defineRule } from 'vee-validate';
import { all } from '@vee-validate/rules';

function setupValidationRules() {
    Object.entries(all).forEach(([name, rule]) => {
        defineRule(name, rule);
    });
}

export default setupValidationRules;
